import { useQuery } from "@tanstack/react-query";

import { caseNotesApi } from "@/api";
import { QueryKey } from "@/query/Query";

export function useCaseNotePopout(clientId: string | undefined, noteId: string | undefined) {
  const { data, isLoading } = useQuery({
    queryKey: [QueryKey.ClientCaseNotes, clientId],
    queryFn: () => {
      if (clientId) {
        return caseNotesApi.getCaseNotesByClientId({ clientId });
      }
    },
    enabled: !!clientId,
  });

  const caseNote = data?.find((note) => note.caseNoteId === noteId) ?? null;

  return { caseNote, isLoading };
}
